import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider } from 'react-redux';
import {store, persistor} from './redux/store';
import reportWebVitals from './reportWebVitals';
import {SnackBarContextProvider } from './components/snackbar';
import {PersistGate} from "redux-persist/integration/react";
import { BasketContextProvider } from './components/basketDrawer';

//import {storage} from './firebase';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <SnackBarContextProvider>
                <BasketContextProvider>
                    <App />
                </BasketContextProvider>
            </SnackBarContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
